export class FabShopStockProductTypeMaterial {
    id!: string
    matlGroup!: number
    material!: string
    fabShopStockProductTypeId!: string
}
